/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ChildComponent from '../../Utility/Component/ChildComponent';
import StreakTrackerRuleBase from './StreakTrackerRuleBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Reel configuration child component for [[StreakTrackerRuleBase]]. */
@cc._decorator.ccclass
export default class ReelConfigComponent extends ChildComponent<StreakTrackerRuleBase>
{
    /** Represents that any available offset is valid. */
    public static readonly AllOffsets: number = -1024;

    /** ReelIndex for this configuration. */
    @property({ visible: true })
    private _reelIndex: number = 0;
    /** Public accessor for ReelIndex */
    public get ReelIndex(): number { return this._reelIndex; }
    /** Public setter for ReelIndex */
    public set ReelIndex(value: number) { this._reelIndex = value; }

    /** Restricted to [[Symbol]] ID. */
    @property({ visible: true })
    private _symbolId: string = "A";
    /** Public accessor for config Symbol ID. */
    public get SymbolId(): string { return this._symbolId; }
    /** Public setter for config Symbol ID */
    public set SymbolId(value: string) { this._symbolId = value; }

    /** Valid offset. */
    @property({ visible: true })
    private _symbolOffset: number = ReelConfigComponent.AllOffsets;
    public get SymbolOffset(): number { return this._symbolOffset; }
    public set SymbolOffset(value: number) { this._symbolOffset = value; }
}
